import useRedirect, {IRedirectOptions} from './useRedirect';
import {ReactElement, useEffect} from "react";

interface IProps extends IRedirectOptions {
    to: string;
}

export default function Redirect(props: IProps): ReactElement {
    const {to, ...rest} = props;
    const redirect = useRedirect();

    useEffect(() => {
        redirect(to, rest);
    }, []);


    return null;
};
